var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "2 2 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e8e4da",
    d: "M12 11.8c2.4 0 4.3-1.9 4.3-4.3S14.4 3.2 12 3.2 7.6 5.1 7.6 7.5c0 1.2.5 2.3 1.3 3.1s1.9 1.2 3.1 1.2m0 2.2s-8.7 1.5-8.7 4.3v2.2h17.3v-2.2c0-2.9-8.7-4.3-8.7-4.3z",
    "data-name": "Path 358"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0-.1h24v24H0z",
    "data-name": "Path 359",
    style: {
      fill: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserWhite);
export default __webpack_public_path__ + "static/media/user-white.5dc83d295a67021a7eeefc7e47dbe504.svg";
export { ForwardRef as ReactComponent };